import React from 'react';
import BaseSelect from 'components/common/BaseSelect/BaseSelect';
import SearchDropDownWrapper from '../SearchDropDownWrapper/SearchDropDownWrapper';

const SearchDropDown = (props) => {
  const { options, selectedId, onChange, label, placeholder, clearable } = props;

  return (
    <SearchDropDownWrapper {...props}>
      <BaseSelect
        defaultSelect={false}
        isClearable={clearable != null ? clearable : true}
        label={label}
        value={selectedId}
        placeholder={placeholder || 'All'}
        options={options}
        onChange={(option) => onChange(option)}
      />
    </SearchDropDownWrapper>
  );
};

export default SearchDropDown;
